/**
 *
 *Redirects to different application view
 * @param {string} view
 * @this {import('sAction').default}
 */
export default function redirectToView(view) {
    switch (view) {
        case 'desktop':
            window.location = `/`;
            break;
        case 'mobile':
            window.location = `/mobile`;
            break;
        case 'servis':
            window.location = `/servis`;
            break;
        default:
            this.error('Unknown view in redirectToView');
            break;
    }
}
